import React from "react";
import { DatePicker } from "@mui/x-date-pickers";

const CustomDatePicker = React.forwardRef(function CustomDatePicker(props, ref) {
    return <DatePicker showDaysOutsideCurrentMonth fixedWeekNumber={6} {...props} inputRef={ref} />;
});

export default CustomDatePicker;
